import { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { ClientRating } from './components';

export const Vote: FC = () => {
  const { t } = useContext(LocalizationContext);
  return (
    <>
      <SettingsBlock title={t('vote')}>
        <SettingsFrame>
          <ClientRating />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
